import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { authLogin, getCountryList } from "../Api/authCrud";
import { ErrorMessage, SuccessMessage } from "../../../components/CustomAlert";
import { HTTP_CODE } from "../../../components/ApiConst";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import LoadingButton from '@mui/lab/LoadingButton';
import './verification_code_input/style.css'
import { CircularProgress } from "@mui/material";
import { color, style } from "@mui/system";
import { getCountryPg } from "../../../components/ApiConst";

function Login(props) {
  const initialValues = {
    password: "",
    username: "",
    email: "",
  };

  const phoneInputRef = useRef("");

  // useEffect(() => {
  //   phoneInputRef.current.focus();
  // }, []);
  const { onLoginSuccess, onLoginFailed, org_instance_id, intl, } = props;
  const [ipadd, setipadd] = useState(null);
  const [reloadCountryApi, setReloadCountryApi] = useState(false);
  const [useagent, setuseagent] = useState(null);
  const [countryData, setCountryData] = useState([]);
  const [showPhnnumInput, setShowPhnnumInput] = useState(false);
  const [showUsernameInput, setShowUsernameInput] = useState(true);
  const [fetchCountryId, setFetchCountryId] = React.useState('');
  const [passwordType, setPasswordType] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const { t, i18n } = useTranslation();
  const donate_url = process.env.REACT_APP_DONATION_SITE;
  const handlePasswordChange = (evnt) => {
    setPasswordInput(evnt.target.value);

    formik.setFieldValue("password", evnt.target.value)
  };
  const togglePassword = (value) => {

    if (value) {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  const history = useNavigate();

  const [loading, setLoading] = useState(false);
  const LoginSchema = Yup.object().shape({
    // email: Yup.string()
    //   .email("Wrong email format")
    //   .min(3, "Minimum 3 symbols")
    //   .max(50, "Maximum 50 symbols"),
    // // .required(
    // //   intl.formatMessage({
    // //     id: "AUTH.VALIDATION.REQUIRED_FIELD",
    // //   })
    // // ),
    // username: Yup.string()
    //   .min(3, "Minimum 3 characters")
    //   .max(50, "Maximum 50 characters")
    //   .required
    //   // intl.formatMessage({
    //   //   id: "AUTH.VALIDATION.REQUIRED_FIELD",
    //   // })
    //   (),
    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required
      // intl.formatMessage({
      //   id: "AUTH.VALIDATION.REQUIRED_FIELD",
      // })
      (),
  });
  let location = useLocation();

  const [variant, setVariant] = useState("success");
  const [message, setMessage] = useState("");
  const [snak, setSnak] = React.useState(false);
  const [isPhnNumValue, setisPhnNumValue] = useState(null)
  function snakClose() {
    setSnak(false);
  }

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };
  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      if (initialValues.password == values.password && initialValues.username == values.username) {
        showUserDeleteError("Try with different username/password");
        return;
      }
      enableLoading();
      setTimeout(() => {
        setLoading(true)
        authLogin(values.password, values.username, org_instance_id, fetchCountryId)
          .then((resp) => {
            setLoading(false)
            // dispatch(Login(resp.data));
            if (resp.status === HTTP_CODE.ACCEPTED) {                   
              localStorage.setItem("token", resp.data.data.access_token);
              localStorage.setItem("loginUserId", resp.data.data.user.id);
              localStorage.setItem("ref_token", resp.data.data.refresh_token);
              localStorage.setItem("postId", resp.data.data.posts[0].id);
              localStorage.setItem("session_id", resp.data.data.session_id);
              localStorage.setItem("persist:v713-demo1-auth", JSON.stringify(resp.data, null, 2));
              localStorage.setItem("post_maskId", resp.data.data.posts[0]?._id);
               localStorage.setItem("admin_id",resp.data.data.posts[0].roles_data.unique_id)
              localStorage.setItem("org-admin",resp.data.data.org_admin)
              localStorage.setItem("client-admin",resp.data.data.client_admin)
              localStorage.setItem("user-admin",resp.data.data.admin)
              disableLoading();
              onLoginSuccess(resp);
              toast.success(resp?.data?.massage, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
              });
            } else if (resp.status === HTTP_CODE.OK) {
              history("/auth" + resp.data.data.context, { state: resp.data.data });
            } else {
              initialValues.password = values.password;
              initialValues.username = values.username;

              showUserDeleteError(resp?.data?.massage);
            }
          })
          .catch((error) => {
            showUserDeleteError(error?.response?.data?.message);
            setLoading(true)
            history(error.response.data.data.context, { state: error.response.data.data });

            if (error?.response?.status == HTTP_CODE.BADREQUEST && error?.response?.data?.error != "User registration's approval is pending.") {
              history(error.response.data.data.context + "?email=" + values.username + "/" + error?.response?.data?.data?.otp_length, { state: error.response.data.data });
            }
            initialValues.password = values.password;
            initialValues.username = values.username;

          })
          .finally(() => {
            setLoading(false);
          });

      });
    },
  });
  const showUserDeleteError = (data) => {
    toast.error(data, {
      position: "top-right",
      autoClose: false,
      // hideProgressBar: true,
      closeOnClick: true,
    });
  };

  function LoginSubmit() {
    formik.setFieldTouched("username");
    if (formik.touched["username"] && !formik.errors["username"]) {
      formik.handleSubmit();
    }
  }
  useEffect(() => {
    const timer = setTimeout(() => {
      setReloadCountryApi(true)
    }, 100)
    return () => clearTimeout(timer);

  }, [])
  useEffect(() => {
    getCountryList().then((res) => {
      var data = res.data.results;
      setCountryData(data)
    }
    )
  }, [reloadCountryApi, selectedCountryCode])
  const handlechanged = (data) => {
    let isPhoneNumber = /([A-Za-z])/gm;

    let startdigit = /^\d/gm;
    let startCountryCodeSymbol = /^\+\d/gm;

    let regEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (
      (!isPhoneNumber.test(data) && startdigit.test(data)) ||
      startCountryCodeSymbol.test(data)
    ) {
      setisPhnNumValue(data)
      setShowUsernameInput(false);
      setShowPhnnumInput(true);
    } else if (regEmail.test(data)) {
      setShowUsernameInput(true);
      setShowPhnnumInput(false);
      formik.setFieldValue("username", data);
    } else {
      setShowUsernameInput(true);
      setShowPhnnumInput(false);
      formik.setFieldValue("username", data);
    }
  };
  const handleOnChangedd = (...args) => {
    // ref.current.focus();
    if (args[3] == "") {
      setShowUsernameInput(true)
      setShowPhnnumInput(false);

    }
    var countryCode = args[1].dialCode;
    var phnNum = args[0].match(/\d{10}$/);

    formik.setFieldValue("username", phnNum);
    // formik.setFieldValue("phn_nbr", phnNum);
    // formik.setFieldValue("country_id", countryCode);
    setSelectedCountryCode(countryCode)
    getCountryCode(countryCode);
    // getCountryPg()
  };
  const getCountryCode = (countryCode) => {

    const selectedCountryDialCode = countryData?.filter((elm) => {
      let dialCode = elm?.dial_code * 1
      return dialCode == countryCode
    })
    setFetchCountryId(selectedCountryDialCode[0]?.id)
  };

  //organisation switch
  const switchOrg = () => {
    localStorage.clear();
    window.location.reload()
  }


  return (
    <>
      <div className="login-form login-signin" id="kt_login_signin_form">
        <div className="stu-logo-img">

          {/* <img src={toplogo} alt="Paris" style={{width:"100%"}}/> */}

        </div>
        <div className="text-left mb-10 " style={{ fontSize: "24px", fontWeight: "600", display: "flex", justifyContent: "center" }}>

          {t('Welcome')}

          {/* <FormattedMessage id="AUTH.LOGIN.TITLE" /> */}
          {/* </h3> */}

        </div>
        <div style={{ textAlign: "center", width: "100%", display: "flex", justifyContent: "center" }}>
          <div style={{ width: "300px" }}>
            <img width={"100%"} style={{ marginBottom: "30px", objectFit: "scale-down" }} src={props?.webConfig?.logo} />
          </div>
        </div>
        {/* end::Head */}

        {/*begin::Form*/}
        <form
          onSubmit={LoginSubmit}
          className="form fv-plugins-bootstrap fv-plugins-framework"
        >
          {showUsernameInput ? (
            <div className="show-user-input">
              <div className="form-group fv-plugins-icon-container">
                {/* <div className=" react-tel-input form-control form-control-lg form-control-solid"> */}
                <input
                  placeholder={t(`Email / Mobile Number`)}
                  autoFocus="true"
                  autocomplete="off"
                  type="username"
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "username"
                  )}`}
                  name="username"
                  // {...formik.getFieldProps("username")}
                  onChange={(e) => handlechanged(e.target.value)}
                />

                {formik.touched.username && formik.errors.username ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.username}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
          {showPhnnumInput ? (
            <>
              <Link
                style={{ color: "#2874f0" }}
                to="/auth/login"
                onClick={() => {
                  setShowUsernameInput(true);
                  setShowPhnnumInput(false);
                }}
              >
                {" "}
                {t(`Email / Mobile Number`)}
              </Link>
              {/* <div className="d-flex"> */}
              {/* <div className="show-phone-input"> */}
              <div className="form-group fv-plugins-icon-container ">
                <ReactPhoneInput
                  className="form-control form-control-lg form-control-solid h-auto px-6 "
                  autocompleteSearch="off"
                  type="username"
                  name="username"
                  country={"in"}
                  autoComplete="off"
                  ref={phoneInputRef}
                  value={isPhnNumValue != null ? isPhnNumValue : null}
                  onChange={handleOnChangedd}
                  inputProps={{

                    autoFocus: true,
                    autoComplete: "off"
                  }}
                />
                {formik.touched.username && formik.errors.username ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.username}
                    </div>
                  </div>
                ) : null}
              </div>
            </>
          ) : null}

          <div className="form-group fv-plugins-icon-container">
            {/* <input
              placeholder="Password"
              type="password"
              className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                "password"
              )}`}
              name="password"
              onInput={() => formik.setFieldTouched("password", true)}
              {...formik.getFieldProps("password")}
            /> */}

            {/* <div className="pc-input-group"> */}
            {/* <div className="pc-input-group-prepend"> */}

            <input
              className="form-control form-control-solid h-auto py-5 px-6 "
              placeholder={t(`Password`)}
              // type="password"
              name="password"
              // onInput={() => formik.setFieldTouched("password", true)}
              // {...formik.getFieldProps("password")}

              type={passwordType}
              onChange={handlePasswordChange}
              value={passwordInput}
            />
            {/* <span className="pc-input-group-text">
            <div className="icon-color"><i className="fa fa-eye"></i></div>
          </span> */}
            {/* </div> */}
            {/* </div> */}


            {formik.touched.password && formik.errors.password ? (
              <div className="fv-plugins-message-container">
                <small className="text-danger">{formik.errors.password} </small>
              </div>
            ) : null}
          </div>
          <div className="form-group d-flex flex-wrap justify-content-between align-items-center fs-14" >
            <div>
              <input type="checkbox" name="ShowPassword" onClick={(e) => togglePassword(e.target.checked)} />
              <label htmlFor="ShowPassword"> {t(`Show Password`)}</label></div>

            <Link
              to="/auth/forgot-password"
              // className="my-3 mr-2"
              id="kt_login_forgot"
              style={{ color: "#2874f0" }}
            >
              {t(`Forgot Password`)} ?
              {/* <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" /> */}
            </Link>


          </div>

          <LoadingButton
            style={{ width: "100%", padding: "12px" }}
            id="kt_login_signin_submit"
            type="submit"
            loading={loading}
            loadingPosition="center"
            loadingIndicator={<CircularProgress style={{ 'color': 'white', 'size': '10px' }} />}
            onClick={formik.handleSubmit}
            // disabled={formik.isSubmitting}
            className={`btn btn-diff-clr fw-bold px-9 py-4 my-3 login-button-sty-button `}
          >
            <span>{t(`Sign In`)}</span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </LoadingButton>

          {
            location.pathname !== "/auth/email-verify" &&
            location.pathname !== "/auth/success-page" &&
            location.pathname !== "/auth/reset-password" &&
            location.pathname !== "/auth/registration" && (
              <div className="position-absolute top-0 fs-16 right-0 mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
                <span className="fw-bold text-dark-50">
                  {t(`I don't have account yet`)}?
                </span>
                <Link
                  to="/auth/registration"
                  className="fw-bold ms-2 ml-rem"
                  id="kt_login_signup"
                  style={{ color: "#2874f0" }}
                >
                  {t(`Sign Up`)}!
                </Link>
              </div>
            )}
          {location.pathname === "/auth/registration" && (
            <div className="position-absolute top-0 fs-16 right-0 mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
              <span className="fw-bold text-dark-50">
                Already have an account?
              </span>
              <Link
                to="/auth/login"
                className="fw-bold ms-2"
                id="kt_login_signup"
              >
                Login now!
              </Link>
            </div>
          )}
        </form>
        <div>
          <p style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }} onClick={switchOrg}>
            switch
          </p>
        </div>
      </div>
      {/* </FadeIn> */}
    </>
  );
}

export default Login;
